import { render, staticRenderFns } from "./krisma.vue?vue&type=template&id=2c2e6f4f&scoped=true&"
import script from "./krisma.vue?vue&type=script&lang=js&"
export * from "./krisma.vue?vue&type=script&lang=js&"
import style0 from "./krisma.vue?vue&type=style&index=0&id=2c2e6f4f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e6f4f",
  null
  
)

export default component.exports